export enum TableType {
  VANGUARD = "Vanguard",
  EXTERNAL = "External",
}
